import { CircularProgress, Box } from "@chakra-ui/react";
import React from "react";

export const LoadingState = ({ text = "Loading..." }) => {
  const [textColor, setTextColor] = React.useState("neutral.700");
  const [loadingColor, setLoadingColor] = React.useState("gray");

  React.useEffect(() => {
    const timer = setTimeout(() => {
      if (textColor === "neutral.700") {
        setTextColor("blue.500");
        setLoadingColor("blue");
      }
      if (textColor === "blue.500") {
        setTextColor("green.500");
        setLoadingColor("green");
      }
      if (textColor === "green.500") {
        setTextColor("red.500");
        setLoadingColor("red");
      }

      if (textColor === "red.500") {
        setTextColor("neutral.700");
        setLoadingColor("gray");
      }
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box h="100%" justifyContent="center" mt="20%">
      <Box textAlign="center">
        <CircularProgress
          size="120px"
          thickness={4}
          isIndeterminate
          color={loadingColor}
        />
        <Box color={textColor} fontFamily="Helvetica" fontSize="24px" mt={2}>
          {text}
        </Box>
      </Box>
    </Box>
  );
};

export const LoadingStateWrapper: React.FC<{
  defaultLoading?: boolean;
  controlled?: boolean;
  children: React.ReactNode | any;
  text?: string;
  passState?: boolean;
  initialize?: (setLoading: (p: boolean) => void) => Promise<any>;
}> = ({
  children,
  defaultLoading = true,
  controlled = true,
  text = "",
  passState = false,
  initialize,
}) => {
  let [loading, setLoading] = React.useState(
    controlled ? defaultLoading : true,
  );
  React.useEffect(() => {
    if (initialize) {
      if (typeof document !== "undefined") {
        console.log("Initializing");
        initialize(setLoading);
      }
    }
  }, []);
  if (loading) {
    return <LoadingState text={text} />;
  }
  if (passState) {
    return children(setLoading);
  }
  return <>{children}</>;
};
